import { Phone, Mail, MapPin, Globe, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { STUDIO } from "@/lib/content";

const items = [
  { icon: Phone, label: "Téléphone", value: STUDIO.phone, href: STUDIO.phoneHref, testid: "contact-phone" },
  { icon: Mail, label: "Email", value: STUDIO.email, href: STUDIO.emailHref, testid: "contact-email" },
  { icon: MapPin, label: "Atelier", value: STUDIO.address, href: null, testid: "contact-address" },
  { icon: Globe, label: "Site web", value: "L'écho du copeau", href: "/", testid: "contact-website" },
];

const Contact = () => (
  <div data-testid="contact-page" className="pt-32 md:pt-40 min-h-screen">
    <section className="px-6 md:px-12 pb-16 md:pb-24">
      <div className="max-w-[1600px] mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] text-[#8B5A33] mb-6">
          Contact
        </p>
          <Reveal>
            <h1 className="font-serif-el font-light text-[13vw] md:text-[8vw] leading-[0.9] tracking-tight">
              Parlons de votre <span className="italic text-[#8B5A33]">projet</span>
            </h1>
          </Reveal>
        <p className="max-w-xl mt-8 font-light text-[#5C564D] text-lg">
          {STUDIO.name} — {STUDIO.tagline}. N'hésitez pas à me contacter pour
          échanger sur vos envies, obtenir un devis ou visiter l'atelier.
        </p>
      </div>
    </section>

    <section className="px-6 md:px-12 pb-28 md:pb-40">
      <div className="max-w-[1600px] mx-auto grid md:grid-cols-2 gap-px bg-[#1C1A18]/10 border-y border-[#1C1A18]/10">
        {items.map((it, i) => {
          const Icon = it.icon;
          const Inner = (
            <>
              <Icon size={22} className="text-[#8B5A33] mb-6" />
              <p className="text-xs uppercase tracking-[0.2em] text-[#5C564D] mb-3">
                {it.label}
              </p>
              <p className="font-serif-el text-3xl md:text-4xl leading-tight break-words">
                {it.value}
              </p>
            </>
          );
          return (
            <Reveal key={it.label} delay={i * 0.08}>
              {it.href ? (
                <a
                  href={it.href}
                  target={it.href.startsWith("http") ? "_blank" : undefined}
                  rel="noreferrer"
                  data-testid={it.testid}
                  className="block bg-[#F4F1EB] p-10 md:p-16 h-full hover:bg-[#EAE5D9] transition-colors duration-500"
                >
                  {Inner}
                </a>
              ) : (
                <div
                  data-testid={it.testid}
                  className="bg-[#F4F1EB] p-10 md:p-16 h-full"
                >
                  {Inner}
                </div>
              )}
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.1}>
        <div className="max-w-[1600px] mx-auto mt-10 flex items-center gap-3 text-[#5C564D]">
          <Clock size={18} className="text-[#8B5A33]" />
          <span className="font-light text-lg">{STUDIO.hours}</span>
        </div>
      </Reveal>
    </section>
  </div>
);

export default Contact;
